<template>
  <div ref="mainContainer" class="main-container ">
    <div class="p-6 close-box-wrap">
      <div class="close-box">
        <a href="#" class="btn-back" @click.prevent="goBack">
          <AppIcon name="close" width="16" />
        </a>
      </div>
    </div>
    <div class="p-20 hr-post-media-content">
      <div class="paggination-actions">
        <button
          class="paggination-arrow"
          :disabled="currentPosition === 0"
          @click="getPrevPost"
        >
          <!-- eslint-disable-next-line -->
          <Icon name="arrow-left" width="30" />
        </button>
        <button
          :disabled="lastPage"
          class="paggination-arrow"
          @click="getNextPost"
        >
          <Icon name="arrow-left" width="30" :rotate="180" />
        </button>
      </div>
      <div class="media-container">
        <img
          v-if="
            post[currentPosition] &&
              post[currentPosition].tournament &&
              post[currentPosition].tournament.cover
          "
          :src="post[currentPosition].tournament.cover"
          class="hr-video-element"
          alt=""
        />
        <div
          v-else-if="
            post[currentPosition] &&
              (!post[currentPosition].attachments ||
                post[currentPosition].attachments.length === 0)
          "
        >
          <Loader />
        </div>
        <img
          v-else-if="
            post[currentPosition] &&
              post[currentPosition].attachments &&
              post[currentPosition].attachments[0].type === 'image'
          "
          :src="post[currentPosition].attachments[0].image"
          class="hr-video-element"
          alt=""
        />
        <video
          v-else-if="
            post[currentPosition] &&
              post[currentPosition].attachments &&
              post[currentPosition].attachments[0].type !== 'image'
          "
          class="hr-video-element highlights-video-component"
          :src="post[currentPosition].attachments[0].video"
          controls
          autoplay
          muted
          playsinline
        ></video>
        <div class="highlights-mobile-info-bottom">
          <HRPostMobile
            v-if="!$lodash.isEmpty(post[currentPosition])"
            v-observe-visibility="{
              callback: isVisible =>
                handleScrollIntoViewForViewsTracking(
                  isVisible,
                  post[currentPosition].id,
                  'post'
                ),
              intersection: {
                threshold: 0.1,
              },
            }"
            :hide-cover="post[currentPosition].tournament"
            :post="post[currentPosition]"
            :type="postType[currentPosition]"
            @dotsClick="event => openPopoverMenu(event, post[currentPosition])"
            @pinned="onPostPinned"
          />
        </div>
      </div>
    </div>
    <div ref="popoverClosest" class="hr-post-side-content position-relative">
      <CreatePost
        v-if="
          !$lodash.isEmpty(post[currentPosition]) &&
            postToEdit === post[currentPosition].id
        "
        :key="post[currentPosition].key"
        :author-model="account"
        :post-model="post[currentPosition]"
        class="mb-6"
        @post-created="updatePost"
        @post-cancel="cancelEdit"
      />
      <HRPost
        v-if="!$lodash.isEmpty(post[currentPosition]) && !postToEdit"
        v-observe-visibility="{
          callback: isVisible =>
            handleScrollIntoViewForViewsTracking(
              isVisible,
              post[currentPosition].id,
              'post'
            ),
          intersection: {
            threshold: 0.1,
          },
        }"
        :hide-cover="post[currentPosition].tournament"
        :post="post[currentPosition]"
        :type="postType[currentPosition]"
        @dotsClick="event => openPopoverMenu(event, post[currentPosition])"
        @pinned="onPostPinned"
      />
      <Popover
        :position="popoverPosition"
        :closest="$refs.popoverClosest"
        :post="popoverPost"
        @toggle="closePopover"
        @edit="editPost"
      />
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs';
import { API } from '@/api/config';
import AppIcon from '@/components/atoms/Icon';
import HRPost from './HRPostItem.vue';
import HRPostMobile from './HRPostItemMobile.vue';
import Popover from '@/components/posts/PostPopover';
import { mapActions, mapState } from 'vuex';
import viewsTrackingMixin from '@/mixins/metrics';
import CreatePost from '@/components/posts/CreatePost';
import Loader from '@/components/common/Loader';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'IndividualPostPage',
  components: {
    AppIcon,
    Icon,
    Popover,
    CreatePost,
    HRPost,
    HRPostMobile,
    Loader,
  },
  mixins: [viewsTrackingMixin],
  data() {
    return {
      post: [],
      postToEdit: false,
      postType: [],
      popoverPosition: null,
      popoverPost: null,
      nextPage: '',
      prevPage: '',
      currentPosition: 0,
      lastPage: false,
    };
  },
  watch: {
    '$route.params'({ id }) {
      this.getPost(id);
    },
    currentPosition() {
      if (
        this.currentPosition + 1 === this.post.length &&
        this.nextPage === null
      ) {
        this.lastPage = true;
      }
    },
  },
  created() {
    document.addEventListener('keydown', this.goToPreviousRoute);
    this.historyLimit = 2;
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.goToPreviousRoute);
  },
  mounted() {
    this.getPost(this.$route.params.id);
    const mainContainer = this.$refs.mainContainer;
    if (window.innerWidth < 1100) {
      const hammer = new Hammer(mainContainer);

      // Add swipe event listeners
      hammer.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
      hammer.on('swipeup', this.swipeUp);
      hammer.on('swipedown', this.swipeDown);
    }
  },

  methods: {
    ...mapActions(['getPostDetails', 'errorNotify']),
    ...mapState('my', ['account']),
    closePopover(isVisible) {
      if (!isVisible && !this.modalIsShow) {
        this.popoverPosition = null;
        /* commented, because modal opened after this function and PostPopover can not delete post (=== null)
        this.popoverPost = null;
        */
      }
    },

    swipeUp() {
      // Handle swipe up event
      this.getNextPost();
    },

    swipeDown() {
      // Handle swipe down event
      if (this.currentPosition !== 0) {
        this.getPrevPost();
      }
    },
    async getNextPost() {
      this.currentPosition = this.currentPosition + 1;
      if (
        this.currentPosition + 2 > this.post.length &&
        this.nextPage !== null
      ) {
        const response = await API(
          `posts/homepage/highlights?page=${this.nextPage}&page_size=10`
        );
        this.nextPage = response.data.next_page_token;

        this.prevPage = response.data.prev_page_token
          ? response.data.prev_page_token
          : '';
        const newPosts = response.data.items.map(post => post.post);
        const newPostTypes = response.data.items.map(post => post.post_type);
        // Filter posts so that you dont have duplicated posts in the array (entering post from highlights)
        const filteredPosts = newPosts.filter(
          post => !this.post.find(p => p.id === post.id)
        );
        const filteredPostTypes = newPostTypes.filter(
          (_, index) => !this.post.find(p => p.id === newPosts[index].id)
        );
        this.post = [...this.post, ...filteredPosts];
        this.postType = [...this.postType, ...filteredPostTypes];
      }
    },
    getPrevPost() {
      this.currentPosition = this.currentPosition - 1;
      this.lastPage = false;
    },
    goToPreviousRoute(key) {
      if (key.code !== 'Escape') return;
      this.$router.go(-1);
    },
    getPost(id) {
      this.getPostDetails(id)
        .then(({ post = null, post_type = '' }) => {
          this.post = [post];
          this.postType = [post_type];
        })

        .catch(this.errorNotify);
    },
    editPost(post) {
      if (post) {
        this.postToEdit = post.id;
      }
    },
    cancelEdit(post) {
      if (post) this.postToEdit = false;
    },
    updatePost(post) {
      this.post[this.currentPosition] = {
        ...this.post[this.currentPosition],
        text: post.post.text,
        attachments: post.post.attachments,
      };
    },
    onPostPinned(post) {
      this.post[this.currentPosition].pinned = !post.pinned;
    },
    goBack() {
      if (window.history.length > this.historyLimit) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    openPopoverMenu(position, post) {
      this.popoverPosition = position;
      this.popoverPost = post;
    },
  },
};
</script>

<style lang="scss">
.main-container {
  display: flex;
  justify-content: space-between;
  /* min-height: calc(100vh - ($header-height + $footer-height)); */
  padding: 0px !important;
  background: $new-bg-page;
  height: 100%;
  max-height: calc(100vh - 66px - 48px);
  overflow-y: hidden;
  @media (max-width: 1100px) {
    background: black;
    position: relative;
    flex-wrap: wrap;
    overflow: auto;
    max-height: none;
  }
}

.hr-post-media-content {
  position: relative;
  width: 70%;
  flex-grow: 2;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.hr-post-side-content {
  flex-basis: 1;
  width: 30%;
  min-width: 454px;
  @media (max-width: 1100px) {
    width: 100%;
    min-width: unset;
    display: none;
  }
}
.close-box {
  border-radius: 90%;
  border: 1px solid black;
  @media (max-width: 1100px) {
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #30374a;
    background-color: #181c25;
  }
}

.close-box-wrap {
  overflow-y: hidden;
  max-height: 200px;
  @media (max-width: 1100px) {
    margin: 13px;
    position: absolute;
    left: -30px;
    top: -30px;
    z-index: 10;
  }
}

.hr-post-video {
  height: 60vh !important;
  max-width: 50vw !important;
}

.media-container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2rem;
  @media (max-width: 1100px) {
    align-items: flex-start;
    padding-top: 0px;
    height: 100dvh;
  }
}

.hr-video-element {
  // max-height: 80vh;
  max-width: 50vw;
  flex: 0 0 50%;
  @media (max-width: 1100px) {
    // max-height: unset;
    max-width: unset;
    width: 100%;
    flex: auto;
    height: 100%;
  }
}
</style>
<style lang="scss">
.comment-item {
  word-break: break-all;
  @media (max-width: 1100px) {
    @include auto-rtl(padding-right, 10px);
  }
}
.hr-post-wrapper {
  .mobile-hide {
    display: none;
  }
  @media (max-width: 1100px) {
    .post-comments-sum {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
  }
  .comment-item {
    @include auto-rtl(padding-left, 34px);
    @include auto-rtl(padding-right, 10px);
    @media (max-width: 1100px) {
      .post-comments-sum {
        padding: 10px !important;
      }
      .header-comment-item {
        display: none !important;
      }
      padding-left: 10px;
      padding-right: 14px;
    }
  }
  .text-input-container {
    @include auto-rtl(margin-right, 5% !important);
    // background-color: #181c25 !important;;
  }
  .textarea-container {
    background-color: #181c25 !important;
    // max-width: 60vw !important;
  }
  .textarea {
    // background-color: #181c25 !important;
  }
  .text-truncate {
    // background-color: #181c25 !important;
  }
  margin-left: 0;
  .post-comments-sum {
    @include auto-rtl(padding-left, 34px);
    @include auto-rtl(padding-right, 10px);
    margin-top: 10px !important;
  }
  @media (max-width: 1100px) {
    padding-bottom: 20px;
    display: block;
    // background-color: #181c25;
    .post-comments-sum {
      padding-bottom: 0px;
      padding-left: 10px !important;
      margin-bottom: 16px;
      margin-top: 0px !important;
    }

    .gif-icon {
      display: none !important;
    }
    .emoji-icon {
      display: none !important;
    }
    .form {
      margin-top: 15px !important;
    }
    .comment-section {
      max-width: 95vw !important;
      word-break: break-all !important;
      .bdi-wraper-text {
        display: block;
        text-align: start;
      }
    }
    .header-comment-item {
      display: block !important;
    }
    hr {
      margin: 0;
    }
    .comment-input-footer {
      margin-top: 0px !important;
    }
    .sc-post-attach {
      max-width: 60vw;
    }
    .text-input-container {
      margin-right: 5% !important;
      // background-color: #11171f !important;
    }
    .text-truncate {
      // background-color: #181c25 !important;
    }
    .textarea-container {
      background-color: #181c25 !important;
      // max-width: 60vw !important;
    }
    .textarea {
      background-color: #181c25 !important;
    }
    .textarea-bottom {
      background-color: #181c25 !important;
    }
    .comment-input-action-emoji {
      display: none;
    }
    .comment-input-action-gif {
      display: none;
    }
  }
}

html[dir='rtl'] {
  .comment-attachments {
    @media (max-width: 1100px) {
      margin-left: 5% !important;
    }
  }
}
.paggination-actions {
  position: absolute;
  display: flex;
  @include auto-rtl(right, 40px);
  top: 40px;
  z-index: 100;
  gap: 10px;
  @media screen and (max-width: 1100px) {
    display: none;
  }
}
.paggination-arrow {
  border-radius: 50%;
  background: #181c25;
  height: 40px;
  width: 40px;
  font-size: 2rem;
  color: white;
  border: 1px solid #30374a;
  display: flex;
  justify-content: center;
  align-items: center;

  .app-rtl & {
    transform: scale(-1);
  }
}

.highlights-mobile-info-bottom {
  display: none;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;

  @media screen and (max-width: 1100px) {
    display: block;
    position: fixed;
    bottom: 50px;
  }
}

.highlights-avatar-mobile {
  height: 40px;
  border-radius: 5px;
}

.highlights-mobile-info-cont {
  display: flex;
}

.highlights-bottom-desc {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.highlights-video-component {
  max-height: 100%;
}

@media screen and (max-width: 1100px) {
  .com-sum-mobile {
    @include auto-rtl(margin-left, 24px);
  }
}
</style>
